import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { changeSelectionDragState } from '../../../features/ui/uiSlice';

export const useCanvasSelectionHandler = () => {
  const dispatch = useDispatch();

  const handleSelectionDrag = useCallback(
    (isDragging: boolean) => {
      dispatch(changeSelectionDragState(isDragging));
    },
    [dispatch]
  );

  return {
    handleSelectionDrag,
  };
};
